import { Spinner } from "react-bootstrap"
import { getTableDate } from "../../../../services/utils"
import { AnswerListOverviewDto } from "../../../../types/CompanyAnswersTypes"
import DisplayBox from "../../../../ui-elements/DisplayBox/DisplayBox"
import Table from "../../../../ui-elements/Table/Table"
import AnimateHeight from "react-animate-height"
import { useEffect } from "react"
import React from "react"

interface IProps {
    data: AnswerListOverviewDto | null
}
const Logs: React.FC<IProps> = ({ data }) => {
    const [isOpen, setIsOpen] = React.useState<Boolean>(false)
    useEffect(() => {
        if (data !== null) {
            setIsOpen(true)
        }
    }, [data])
    if (data === null) return <DisplayBox
        title="Atburðaskrá"
        id="atburdaskra"
        asideComponent={
            <Spinner className='loading-spinner' animation="border" />
        }
    />
    return <DisplayBox
        title="Atburðaskrá"
        displayBoxSize="lg"
        id="atburdaskra"
    >
        <AnimateHeight
            className="dagatal-item__content"
            duration={300}
            height={isOpen ? 'auto' : 0}
        >
            {
                <Table showEmptyTableText emptyTableText="Engir atburðir hafa átt sér stað" data={data.logs} columns={[{
                    title: 'Dags.',
                    renderCell: ({ createdTimestamp }) => getTableDate(createdTimestamp, "DD/MM/YYYY HH:MM:SS", "."),
                    textAlign: 'left'
                }, {
                    title: 'Aðgerð',
                    renderCell: ({ operation }) => operation,
                    textAlign: 'left'
                }, {
                    title: 'Skilaboð',
                    renderCell: ({ message }) => message,
                    textAlign: 'left'
                }, {
                    title: 'Fyrirtæki',
                    renderCell: ({ customerName }) => customerName,
                    textAlign: 'left'
                }, {
                    title: 'Framkvæmt af notanda',
                    renderCell: ({ createdBy }) => createdBy,
                    textAlign: 'left'
                }]} />
            }
        </AnimateHeight>
    </DisplayBox>
}

export default Logs;